import Icon from '@/root/ui/shared/Icon'
import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'

export const EmailIconBlue: FC<IconProps> = ({ width = 24, height = 24, ...rest }) => (
  <Icon type="EmailBlue" width={width} height={height} alt="iconEmailBlue" ignoreRtl {...rest} />
)
